import styled from 'styled-components';
import { fixMeasure, Measure } from '../../shared/styled-components';

interface IProps {
    gridArea?: string;
    minHeight?: Measure;
}

const CardContainer = styled.div<IProps>`
  grid-area: ${p => p.gridArea};

  min-height: ${p => p.minHeight && fixMeasure(p.minHeight)};
  padding: 0.5rem;
  border-radius: 0.5rem;
  
  background-color: ${p => p.theme.palette.white};
  box-shadow: ${p => p.theme.effects.elevation4};
`;

export default CardContainer;